import React, { useEffect, useState } from 'react';
// import './Management3.css';
import image from "../../../../images/wallet.avif";
import { FaEye, FaTrash } from 'react-icons/fa';
import axios from 'axios';
import Grocerycashbilling from "../accountpages/importpages/Grocerycashbilling";
// import "./Company.css";
// import "./Style.css";
import Grocerysettlement from "./importpages/Grocerysettlement";
import Grocerywalletadd from "./importpages/Grocerywalletadd";


// all the data formated code also not digital formated in the re

const Grocerymanagement3 = () => {
  const [activeTab, setActiveTab] = useState('Cash Billing');
  const [vendorId, setVendorId] = useState(null);
  const isMobile = useState(window.innerWidth < 768);
  const [selectedDate, setSelectedDate] = useState(""); // format: YYYY-MM-DD

  const [allOrders, setAllOrders] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  // const [selectedDate, setSelectedDate] = useState("");

  // 1️⃣ Fetch orders
  useEffect(() => {
    if (!vendorId) return;

    const fetchOrders = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("Authorization token is missing");
        return;
      }

      try {
        const res = await axios.get(
          `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/getall/${vendorId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const orders = res.data || [];
        setAllOrders(orders);
        setFilteredData(orders);

        // ✅ Calculate totals
        let walletIncome = 0;
        let onlineIncome = 0;
        let cashIncome = 0;

        orders.forEach(order => {
          if (order.paymentStatus?.toLowerCase() === "paid" || order.paymentStatus?.toLowerCase() === "completed") {
            const amount = order.total || 0;
            const method = order.paymentMethod?.toLowerCase();

            if (method === "maamaas_wallet" || method === "wallet") {
              walletIncome += amount;
            } else if (method === "online" || method === "online_payment" || method === "razorpay") {
              onlineIncome += amount;
            } else if (method === "cash") {
              cashIncome += amount;
            }
          }
        });

        const totalIncome = walletIncome + onlineIncome + cashIncome;

        setTotals({
          walletIncome,
          onlineIncome,
          cashIncome,
          totalIncome,
        });

      } catch (err) {
        console.error("❌ Error fetching orders:", err);
      }
    };

    fetchOrders();
  }, [vendorId]);


  // 2️⃣ Filter orders based on selected date
  useEffect(() => {
    if (!selectedDate) {
      setFilteredData(allOrders); // show all if no date selected
      return;
    }

    const filtered = allOrders.filter((order) => {
      const orderDate = new Date(order.orderDateAndTime)
        .toISOString()
        .split("T")[0]; // format YYYY-MM-DD
      return orderDate === selectedDate;
    });

    setFilteredData(filtered);
  }, [selectedDate, allOrders]);

  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) {
      setVendorId(storedVendorId);
    }
  }, []);
  const [totals, setTotals] = useState({
    totalIncome: 0,
    walletIncome: 0,
    onlineIncome: 0,
    cashIncome: 0,
  });



  const exportToCSV = () => {
    if (filteredData.length === 0) {
      alert("No data to export!");
      return;
    }

    // 1️⃣ Build CSV header
    const headers = [
      "S.No",
      "Order ID",
      "Date",
      "Category",
      "Type",
      "Name",
      "Payment",
      "Order Status",
      "Amount",
    ];

    // 2️⃣ Build CSV rows
    const rows = filteredData.map((item, index) => [
      index + 1,
      item.orderId,
      new Date(item.orderDateAndTime).toLocaleDateString("en-GB"),
      item.appType,
      item.orderType || item.orderService,
      item.userName,
      item.paymentMethod,
      item.status,
      Math.round(item.grandTotal),
    ]);

    // 3️⃣ Combine header + rows
    const csvContent =
      [headers, ...rows]
        .map((row) => row.map((v) => `"${v}"`).join(",")) // wrap each value in quotes
        .join("\n");

    // 4️⃣ Create a blob and download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `orders_${new Date().toISOString().split("T")[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };



  // {=======================overview===============================}
  const tabContent = {
    Overview: <div style={{ marginTop: "20px" }}>
      <div className="status-overview">
        {[
          { title: "Total Income", value: totals.totalIncome },
          { title: "Wallet Income", value: totals.walletIncome },
          { title: "Online Income", value: totals.onlineIncome },
          { title: "Cash Income", value: totals.cashIncome },
        ].map((card, idx) => (
          <div key={idx} style={{ background: "#2c6eaa", color: "#fff" }} className="status-card dine-in">
            {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "30px", marginTop: '20px' }}>
              <img src={image} alt="icon" style={{ height: '50px', borderRadius: '10px' }} />
            </div> */}
            <h4 style={{ display: 'flex', justifyContent: "center" }}>{card.title}</h4>
            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>₹{card.value.toLocaleString("en-IN")}</p>
          </div>
        ))}
      </div>
      <div className="status-overview">
      </div>



      <div className="payment-history-container">
        <style>
          {`
          .payment-history-container {
           
            box-sizing: border-box;
            width: 100%;
            max-width: 100%;
          }

          .payment-heading {
            text-align: center;
            margin-bottom: 15px;
            font-size: 20px;
          }

          .filter-bar {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            gap: 10px;
            margin-bottom: 15px;
            align-items: center;
          }
    .filters {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
            gap: 10px;
            
            
          }
              .filters select {
            padding: 8px 10px;
            border-radius: 5px;
            border: 1px solid #ccc;
            margin-right: 10px;
            min-width: 120px;
            background-color: #b15cd6;
            color: #fff;
            font-weight:bold;
          }

          .filters button {
            padding: 10px 20px;
            background-color: #b15cd6;
            color: #fff;
            border: none;
            border-radius: 5px;
            font-weight: bold;
            cursor: pointer;
            white-space: nowrap;
          }
          .filter-group {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
          }

          .filter-group select {
            padding: 6px;
            background-color:#b15dc6;
            color: white;
            font-weight:bold;
            border-radius: 5px;
            border: 1px solid #ccc;
            min-width: 100px;
            font-size: 14px;
          }

          .export-button {
            padding: 4px 8px;
            background-color: #b15dc6;
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            font-size: 14px;
            white-space: nowrap;
           
          }

          .table-wrapper {
            width: 100%;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            background: #fff;
            // border: 1px solid #ddd;
            border-radius: 8px;
          }

          table {
            width: 100%;
            min-width: 850px;
            border-collapse: collapse;
          }

          th, td {
            border: 1px solid #ddd;
            padding: 10px;
            font-size: 13px;
            text-align: left;
            white-space: nowrap;
          }

          th {
            background-color: #b15dc6;
            font-weight: bold;
            font-size: 14px;
          }

          tr:nth-child(even) {
            background-color: #ffffff;
          }

          tr:nth-child(odd) {
            background-color: #f9f9f9;
          }

          @media screen and (max-width: 768px) {
            .filter-bar {
              //  flex-direction: column;
              align-items: flex-start;
            }




             @media screen and (max-width: 480px) {
            .filter-bar {
              //  flex-direction: column;
              align-items: flex-start;
            }

            .payment-history-container{
            max-width:100%;
            padding:0px;
            }
            

            .export-button {
              align-self: flex-end;
            }

            .table-wrapper {
              border: 1px;
              border-radius: 0;
              padding-bottom: 10px;
            }

            table {
              min-width: 600px;
            }
           
          }
        `}
        </style>

        {/* <h4 className="payment-heading">Payment History</h4> */}

        <div >
          <div className="filters">
            <div>
              <button>
                <input
                  type="date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  style={{ background: "rgb(177 92 214)", color: "#fff", border: "none" }}
                /></button>
            </div>
            <button onClick={exportToCSV}>Export</button>
          </div>

          {/* <button className="export-button">Export</button> */}
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>OrderID</th>
                <th>Transaction ID</th>
                <th>Date & Time</th>
                <th>Name</th>
                <th>Payment</th>
                <th>Status</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>No orders for selected date</td>
                </tr>
              ) : (
                filteredData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.orderId}</td>
                    <td>{item.transactionId || "-"}</td>
                    <td>{new Date(item.orderDateTime).toLocaleString()}</td>
                    <td>{item.userName}</td>
                    <td>{item.paymentMethod}</td>
                    <td>{item.paymentStatus}</td>
                    <td>₹{Math.round(item.total)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>,






    "Cash Billing": <Grocerycashbilling />,


    // {=======================all===============================}
    Settlement: <Grocerysettlement />,

    // Wallet: <Grocerywalletadd />,


  };

  <style>{`
        .main-container {
         
          display: flex;
          flex-direction: column;
         
        }

         .tabs-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left:0px;
}



/* Mobile view ke liye (max-width 768px ya 600px aapke design ke hisaab se) */
@media screen and (max-width: 768px) {
  .tabs-wrapperpayment {
    margin-left: 0;
    
  }
}


        .overviewbuttonsyy{
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          margin-top:81px;
          text-align:center;
         
        }

        .overviewbuttonsyy{
          border: none;
          border-radius: 10px;
          width: 150px;
          height: 40px;
          background-color: #d9d9d9;
          color: #000;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .overviewbuttons.active {
          background-color: #b15cd6;
        }

        .tab-content {
          margin-top: 20px;
          width: 100%;
          max-width:840px;
          
        }

        .sidebar {
          margin-top: 30px;
          max-height: 600px;
          overflow-y: auto;
        }

        .card {
          width: 100%;
          max-width: 300px;
          height: 120px;
          background: #ccc;
          border-radius: 8px;
          box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
          margin: 10px auto;
          position: relative;
          padding: 10px;
        }

        .card h5, .card p {
          color: white;
          margin: -18 !imortanant;
        }

        .overviewbuttonsyy{
         text-align:center;
          }

        
        @media (min-width: 768px) {
          .main-container {
            flex-direction: row;
            justify-content: space-between;
          }

          // .overviewbuttonsyy{
          // margin-left:29px;
          // }

          

          .left-column {
            width: 100%;
            padding-right: 95px;
            max-height: 700px;
           
          }

          .right-column {
            width: 30%;
            position: sticky;
            top: -30px;
            max-height: 700px;
            overflow-y: auto;
          }

          .card {
            margin-left: 0;
          }
            .tabs-wrapperpayment{
            margin-left:none

            }

        }

        /* Hide native scrollbars */
        .sidebar::-webkit-scrollbar,
        .left-column::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }
      `}</style>

  return (
    <div className="container-fluid">
      <div className="row">

        <div className="col-lg-12 col-md-12 col-sm-12">


          {/* Left Section */}
          <div className="left-column" style={{}}>
            <div className="tabs-wrapperpayment ">

              <div style={{ textAlign: 'center' }}>
                {Object.keys(tabContent).map((label) => (
                  <button style={{
                    backgroundColor: activeTab === label ? '#b15dc6' : '#d9d9d9',
                    border: 'none',
                    borderRadius: '10px',
                    width: '150px',
                    height: '40px',
                    color: 'black',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                    margin: '10px' // To simulate gap of 10px between buttons (5px top/bottom + 5px left/right)
                  }}
                    key={label}
                    className={`overviewbuttons ${activeTab === label ? "active" : ""}`}
                    onClick={() => setActiveTab(label)}
                  >
                    {label}
                  </button>


                ))}
              </div>
              <div
                className="tab-content"
                style={{
                  overflow: 'auto',
                  height: isMobile ? '500px' : '520px',
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  maxWidth: '944px',
                }}
              >
                {tabContent[activeTab]}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};





export default Grocerymanagement3;
